<template>
  <v-container ma-0 pa-0>
    <v-btn color="secondary" class="ml-0" @click="snackbar = true">View snackbar</v-btn>
    <v-snackbar v-model="snackbar" color="tertiary" top>
      Lorem ipsum dolor sit amet lorem ipsum dolor sit amet.
      <v-btn dark flat icon @click="snackbar = false">
        <v-icon>cancel</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: "Snackbar",
  data: function() {
    return {
      snackbar: ""
    }
  }
}
</script>
